import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';


export const accountSearchResultCreditAlertsUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultCreditAlertsUsers');

export const accountSearchResultCreditAlertsUsersActions = accountSearchResultCreditAlertsUsersSlice.actions;

const accountSearchResultCreditAlertsUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.creditAlertsUsers.cache;
export const accountSearchResultCreditAlertsUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.userPage.tabs.assignedAccounts.creditAlertsUsers;
export const accountSearchResultCreditAlertsUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultCreditAlertsUsersCacheSelector,
    accountSearchResultStateSelector,
);
